function isObject(value: any) {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

// * As per https://github.com/axios/axios/issues/5630#issuecomment-1828448874
export const serializeQS = (params: Record<string, any>) =>
  Object.keys(params)
    .filter((key) => params[key] !== undefined)
    .map((key) => {
      if (isObject(params[key])) {
        params[key] = JSON.stringify(params[key]);
      }
      if (Array.isArray(params[key])) {
        return params[key]
          .map((v: any) => `${key}[]=${encodeURIComponent(v)}`)
          .join('&');
      }
      return `${key}=${encodeURIComponent(params[key])}`;
    })
    .join('&');
